<template>
  <el-dialog custom-class="algorithm-select-container dialog-size-middle"
             title="アルゴリズムの選択"
             top="0"
             :modal="false"
             :append-to-body="true"
             :visible.sync="visible"
             @open="$emit('open')"
             @close="$emit('close')"
             @closed="$emit('closed')">
    <div class="algorithm-select-container-inner">
      <el-menu class="algorithm-select-navi-container" mode="vertical" unique-opened="true"
               :default-active="selectedAlgorithm && selectedAlgorithm.enabled ? selectedAlgorithm.algorithmId : ''">
        <el-submenu v-for="algorithmCategory in algorithmsCategories" :index="algorithmCategory.categoryId">
          <template slot="title">
            <span slot="title">{{ algorithmCategory.categoryName }}</span>
          </template>
          <el-menu-item :index="algorithmSummary.algorithmId"
                        v-for="algorithmSummary in filterEnabledAlgorithmSummaries(algorithmCategory)"
                        @click="onClickMenuItem(algorithmSummary)">
            <span slot="title">{{ algorithmSummary.algorithmName }}</span>
          </el-menu-item>
        </el-submenu>
      </el-menu>
      <div class="algorithm-select-main-container">
        <h2>{{selectedAlgorithm && selectedAlgorithm.enabled ? selectedAlgorithm.algorithmName : ''}}</h2>
        <p v-html="selectedAlgorithm && selectedAlgorithm.enabled ? $options.filters.html_format(selectedAlgorithm.description.text) : ''"></p>
        <!--<p v-html="$options.filters.html_format(selectedAlgorithm.description.text)"></p>-->
        <div class="algorithm-select-main-img-container">
          <img v-if="selectedAlgorithm && selectedAlgorithm.enabled && selectedAlgorithm.description.imgUrl"
               :src="selectedAlgorithm.description.imgUrl">
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible=false">キャンセル</el-button>
      <el-button type="primary" @click="onClickSelect">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { AlgorithmSummary } from '../../../../defines/algorithm'

export default {
  name: 'AlgorithmSelectDialogCmp',
  props: {
    algorithmsCategories: Array,
    selectedAlgorithmForInit: AlgorithmSummary
  },
  data () {
    return {
      selectedAlgorithm: this.selectedAlgorithmForInit,
      visible: true
    }
  },
  methods: {
    onClickMenuItem (algorithmSummary) {
      this.selectedAlgorithm = algorithmSummary
      this.$forceUpdate()
    },
    onClickSelect () {
      this.visible = false
      this.$emit('select', this.selectedAlgorithm)
    },
    filterEnabledAlgorithmSummaries (algorithmCategory) {
      return algorithmCategory.algorithms.filter(algorithm => algorithm.enabled)
    }
  }
}

</script>

<style type="scss" scoped>
  .algorithm-select-container-inner {
    display: flex;
    flex-direction: row;
    height: 500px;
  }

  .algorithm-select-container-inner > .algorithm-select-navi-container {
    flex-shrink: 0;
    width: 330px;
    overflow-y: scroll;
  }

  .algorithm-select-container-inner > .algorithm-select-main-container {
    flex-shrink: 0;
    flex-grow: 1;
    padding-left: 24px;
    max-width: 630px;
  }

  .algorithm-select-container-inner > .algorithm-select-main-container > h2 {
    margin: 0;
  }

  .algorithm-select-container-inner > .algorithm-select-main-container > p {
    margin-top: 0;
    word-wrap: break-word;
  }

  .algorithm-select-container-inner > .algorithm-select-main-container > .algorithm-select-main-img-container {
    text-align: center;
    padding: 16px 0;
  }

  .algorithm-select-container-inner > .algorithm-select-main-container > .algorithm-select-main-img-container > img {
    width: 480px;
  }
</style>



// WEBPACK FOOTER //
// src/components/model/train/dialogs/algorithm-select.vue